var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4358 4.55729V4.55729C10.4358 3.93731 10.4358 3.62732 10.3676 3.37299C10.1827 2.6828 9.64359 2.14371 8.9534 1.95877C8.69907 1.89062 8.38908 1.89062 7.7691 1.89062H5.54688C3.66126 1.89062 2.71845 1.89062 2.13266 2.47641C1.54688 3.0622 1.54688 4.00501 1.54688 5.89063V8.11285C1.54688 8.73283 1.54688 9.04282 1.61502 9.29715C1.79996 9.98734 2.33905 10.5264 3.02924 10.7114C3.28357 10.7795 3.59356 10.7795 4.21354 10.7795V10.7795",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    y: 6.22266,
    width: 8.88889,
    height: 8.88889,
    rx: 2,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2ab457ba32f0b5e53f157ce583989cc1.svg";
export { ForwardRef as ReactComponent };